module.exports = __webpack_public_path__ + "static/media/fem_2.367836de.png";